import * as React from "react";
import Svg, { Circle, Rect, SvgProps } from "react-native-svg";

function SwitchOnIcon(props: SvgProps) {
  return (
    <Svg width={55} height={30} viewBox="0 0 55 30" fill="none" {...props}>
      <Rect
        width={55}
        height={30}
        rx={15}
        transform="matrix(-1 0 0 1 55 0)"
        fill="#2C7A7B"
      />
      <Circle
        cx={13.75}
        cy={13.75}
        r={13.75}
        transform="matrix(-1 0 0 1 53.75 1.25)"
        fill="#FFFFFE"
      />
    </Svg>
  );
}

export default SwitchOnIcon;
